document.addEventListener('DOMContentLoaded', function () {
  var boxes = document.querySelectorAll('.sidebar-filters__checkbox');
  boxes.forEach(function (box) {
    box.addEventListener('change', function () {
      var url = box.checked ? box.getAttribute('data-add-url') : box.getAttribute('data-remove-url');
      if (url) {
        window.location.href = url;
      }
    });
  });
});
